import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Basic validation
    if (!username || !password) {
      setError('Lütfen tüm alanları doldurunuz.');
      setLoading(false);
      return;
    }

    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email: username,
        password: password,
      });

      if (error) throw error;

      if (data.user) {
        // Check if user exists in the users table
        const { data: profileData, error: profileError } = await supabase
          .from('users')
          .select('*')
          .eq('id', data.user.id)
          .eq('status', 'active')
          .single();

        if (profileError) throw profileError;

        // Check if user has necessary permissions
        if (!profileData) {
          throw new Error('Bu panele erişim yetkiniz bulunmamaktadır.');
        }

        localStorage.setItem('user', JSON.stringify(data.user));
        localStorage.setItem('profile', JSON.stringify(profileData));
        navigate('/');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(
        err.message || 'Giriş başarısız. Lütfen bilgilerinizi kontrol ediniz.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-100 h-screen flex items-center justify-center">
      <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-lg">
        <div className="flex justify-center mb-8">
          <img src="/logo.png" alt="UNO Logo" className="h-16" />
        </div>

        <h1 className="text-2xl font-bold text-center text-red-600 mb-8">
          Sürücü Görev Uygulaması Yönetim Paneli
        </h1>

        {error && (
          <div className="mb-4 p-4 text-sm text-red-700 bg-red-100 rounded-lg">
            {error}
          </div>
        )}

        <form className="space-y-6" onSubmit={handleLogin}>
          <div>
            <label
              htmlFor="username"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              E-Posta
            </label>
            <input
              type="email"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
              required
            />
          </div>

          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Parola
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
              required
            />
          </div>

          <div className="flex items-center justify-end">
            <a href="#" className="text-sm text-red-600 hover:text-red-700">
              Şifremi Unuttum?
            </a>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 px-4 bg-red-600 hover:bg-red-700 text-white font-medium rounded-md transition duration-150 ease-in-out disabled:opacity-50"
          >
            {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </button>
        </form>

        <div className="mt-8 text-center space-x-4 text-sm text-gray-600">
          <a href="#" className="hover:text-red-600">
            Contact
          </a>
          <span>•</span>
          <a href="#" className="hover:text-red-600">
            Terms & Conditions
          </a>
          <span>•</span>
          <a href="/gizlilik-politikasi" className="hover:text-red-600">
            Gizlilik Politikası
          </a>
        </div>
      </div>
    </div>
  );
}

export default Login;
